var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../../converters/DateConverter";
export class DatedVatIdentificationNumber {
  constructor(_data) {
    /**
     */
    __publicField(this, "CountryCode");
    /**
     */
    __publicField(this, "DeregistrationDate");
    /**
     */
    __publicField(this, "ValidFrom");
    /**
     */
    __publicField(this, "VatNumber");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof DatedVatIdentificationNumber
     */
    __publicField(this, "$type", "V1.CompanyInfo.Questionnaire.Answers.DatedVatIdentificationNumber");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CountryCode = _data["CountryCode"];
      this.DeregistrationDate = DateConverter.from(_data["DeregistrationDate"]);
      this.ValidFrom = DateConverter.from(_data["ValidFrom"]);
      this.VatNumber = _data["VatNumber"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CountryCode"] = this.CountryCode;
    _data["DeregistrationDate"] = DateConverter.toUtcDateString(this.DeregistrationDate);
    _data["ValidFrom"] = DateConverter.toUtcDateString(this.ValidFrom);
    _data["VatNumber"] = this.VatNumber;
    return _data;
  }
}
